import { Column } from "@shared-ui-components/DataTable/types";
import {
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";

// Functions
export const refineData = (data: any) => {
  const refined = data?.map((el: any) => {
    const refinedObject = {
      name: el.name,
      job: el.job,
      amtAct: el.amt_act,
      amtPct: el.amt_pct,
      total: el.total,
    };
    return refinedObject;
  });
  return refined;
};

// Constants
export const columns: Column[] = [
  { id: "name", label: "Employee", minWidth: 106 },
  {
    id: "job",
    label: "Job Code",
    minWidth: 100,
    align: "left",
  },
  {
    id: "amtAct",
    label: "AMT $",
    minWidth: 94,
    align: "left",
    format: formatNumberWithCommaAndDollar,
  },
  {
    id: "amtPct",
    label: "AMT %",
    minWidth: 76,
    align: "left",
    format: formatWithPercentage,
  },
];
